var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-page",attrs:{"id":"app"}},[_c('div',{staticClass:"mm-layout",class:{'menu-opened': _vm.openedMobileMenu}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }